import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicLineTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-seismic-line-type-container',
  templateUrl: './seismic-line-type-container.component.html',
  styleUrls: ['./seismic-line-type-container.component.scss'],
})
export class SeismicLineTypeContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  linenumbers$: Observable<SeismicLineTypeDto[]>;
  loading: boolean;
  isLoadingLineNumber$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingLineNumber$ = this.gatwayFacade.isLoadingGateway(
      'SeismicLineType'
    );
    this.linenumbers$ = this.gatwayFacade.loadGateway('SeismicLineType');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLineNumber(deletedValue: any) {
    this.gatwayFacade.remove('SeismicLineType', deletedValue);
  }

  // this method control both the create and update

  onSubmitLineNumber(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.LineNumbers;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllLineNumber = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllLineNumber.push(pullData[i]);
      }
    }

    // check if the addAllLineNumber array is not empty, then dispatch the data to the store
    if (addAllLineNumber.length > 0) {
      this.gatwayFacade.add('SeismicLineType', addAllLineNumber);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('SeismicLineType', allUpdates, ['id']);
    }
  }
}
